var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveDues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.55556C3 3.40821 3.06321 3.26691 3.17574 3.16272C3.28826 3.05853 3.44087 3 3.6 3H8.4C8.55913 3 8.71174 3.05853 8.82427 3.16272C8.93679 3.26691 9 3.40821 9 3.55556C9 3.7029 8.93679 3.84421 8.82427 3.94839C8.71174 4.05258 8.55913 4.11111 8.4 4.11111H3.6C3.44087 4.11111 3.28826 4.05258 3.17574 3.94839C3.06321 3.84421 3 3.7029 3 3.55556ZM6 8C6.31826 8 6.62348 7.88294 6.84853 7.67456C7.07357 7.46619 7.2 7.18357 7.2 6.88889C7.2 6.5942 7.07357 6.31159 6.84853 6.10321C6.62348 5.89484 6.31826 5.77778 6 5.77778C5.68174 5.77778 5.37652 5.89484 5.15147 6.10321C4.92643 6.31159 4.8 6.5942 4.8 6.88889C4.8 7.18357 4.92643 7.46619 5.15147 7.67456C5.37652 7.88294 5.68174 8 6 8Z",
    fill: "#50C878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 0C2.03587 0 1.59075 0.210714 1.26256 0.585787C0.934375 0.960859 0.75 1.46957 0.75 2V10C0.75 10.5304 0.934375 11.0391 1.26256 11.4142C1.59075 11.7893 2.03587 12 2.5 12H9.5C9.96413 12 10.4092 11.7893 10.7374 11.4142C11.0656 11.0391 11.25 10.5304 11.25 10V2C11.25 1.46957 11.0656 0.960859 10.7374 0.585787C10.4092 0.210714 9.96413 0 9.5 0H2.5ZM9.5 1.33333H2.5C2.34529 1.33333 2.19692 1.40357 2.08752 1.5286C1.97812 1.65362 1.91667 1.82319 1.91667 2V10C1.91667 10.1768 1.97812 10.3464 2.08752 10.4714C2.19692 10.5964 2.34529 10.6667 2.5 10.6667H9.5C9.65471 10.6667 9.80308 10.5964 9.91248 10.4714C10.0219 10.3464 10.0833 10.1768 10.0833 10V2C10.0833 1.82319 10.0219 1.65362 9.91248 1.5286C9.80308 1.40357 9.65471 1.33333 9.5 1.33333Z",
    fill: "#50C878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDues);
export default __webpack_public_path__ + "static/media/ActiveDues.20fad5d716aea339439bb74732318893.svg";
export { ForwardRef as ReactComponent };